import { Observable } from 'rxjs';
import { IPostTypeProviderOptions, IPostType } from 'projects/models/src/public-api';

export abstract class NgPostTypeProvider<T extends IPostType> {
    abstract get(path?: string, options?: IPostTypeProviderOptions<T>): Observable<T|T[]>;
}


